export default class TriggerElement
{
  constructor()
  {
    this.setVars();
  }
  
  setVars()
  {
    this.settings = {
      class: 'data-click-trigger-class'
    };
    
    this.triggerClass = document.querySelector(`[${this.settings.class}]`);
    
    if (this.triggerClass) {
      this.setEventClass();
    }
  }
  
  setEventClass()
  {
  
    this.triggerClass.addEventListener('click', (e) => {
      e.preventDefault();
      document.querySelector(this.triggerClass.getAttribute(this.settings.class)).triggerEvent('click');
    })
  }
}
